(ns dre.pages.admin.views
  (:require
   [dre.app.router :as-alias router]
   [dre.components.tabs :refer [tabs]]
   [dre.pages.admin.events :as-alias admin]
   [re-frame.core :as rf]))

(def tab-items
  [#_{:id :admin-help
    :label "Help Settings"}
   {:id :admin-feed
    :label "Feed Settings"}
   {:id :admin-survey
    :label "Surveys"}
   {:id :admin-usage
    :label "Usage"}
   {:id :admin-client-download
    :label "Client Downloads"}
   {:id :admin-ai-summarization-usage
    :label "AI Summarization Usage"}])

(defn nav-tabs
  []
  [tabs {:items tab-items
         :on-click #(rf/dispatch [::router/redirect-to-handler (:id %)])
         :default-active-id @(rf/subscribe [::admin/current-page])}])
